// extracted by mini-css-extract-plugin
export var footer = "_ls-0";
export var inherit = "_ls-1";
export var input = "_ls-2";
export var modalContent = "_ls-3";
export var quillEditor = "_ls-4";
export var subtitle = "_ls-5";